import React, {useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

//components:
import {CustomDropdown, NetgraphNavbarBadges} from "../../../../widgets";

//actions:
import {settingsActions} from "../../../../redux/Settings/settingsRedux";

//helpers:
import {getFeaturesRecursively, getDefaultInsightByPreference} from "../../../../../_metronic/_helpers";
import {loadUserParameter} from "../../../../redux_slices/contextSlice";

const TopDropdowns = ({
    selectedTrackMetrics,
    selectedInsights,
    setSelectedTrackMetrics,
    setSelectedInsights,
    setFilteredRankingTopics,
}) => {
    const {t} = useTranslation();

    //redux:
    //store:
    const language = useSelector(state => loadUserParameter(state, "language"));

    const {metricsTracks = [], metricsInsights = [], trackFeaturesRanking = []} = useSelector(state => state.settings);

    //actions:
    const dispatch = useDispatch();
    const getMetricsInsights = trackId => dispatch(settingsActions.getMetricsInsights(trackId));
    const getTrackFeaturesRanking = track =>
        dispatch(settingsActions.getTrackFeaturesRanking(track, language || "en-US"));
    const getMetricsNetgraphData = track =>
        dispatch(settingsActions.getMetricsNetgraphData(track, language || "en-US"));
    const getMetricsNetgraphConfig = type => dispatch(settingsActions.getMetricsNetgraphConfig(type));

    const allAvailableInsights = useMemo(() => getFeaturesRecursively(metricsInsights, true), [metricsInsights]);

    useEffect(() => {
        const hasSelectedMetrics = selectedTrackMetrics?.[0]?.id !== undefined;
        if (hasSelectedMetrics) {
            setFilteredRankingTopics([]);
            getMetricsInsights(selectedTrackMetrics[0].id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTrackMetrics]);

    useEffect(() => {
        if (metricsTracks?.length) {
            const defaultSelectedTrack = metricsTracks.find(track => track.id !== null);

            setSelectedTrackMetrics([defaultSelectedTrack]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [metricsTracks]);

    useEffect(() => {
        //setting selected insight by default:

        if (metricsInsights && metricsInsights.length) {
            //preferences:
            const selectedInsightWithPreference = [getDefaultInsightByPreference(allAvailableInsights)];
            setSelectedInsights(selectedInsightWithPreference);

            if (selectedTrackMetrics && selectedTrackMetrics[0] && selectedTrackMetrics[0].id !== undefined) {
                getTrackFeaturesRanking(selectedTrackMetrics[0].id);
                getMetricsNetgraphData(selectedTrackMetrics[0].id);
                getMetricsNetgraphConfig(6);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [metricsInsights]);

    useEffect(() => {
        const hasFeatures = trackFeaturesRanking?.length;
        const selectedInsightKey = selectedInsights?.[0]?.key;

        if (hasFeatures && selectedInsightKey) {
            const filteredByFeature = trackFeaturesRanking.filter(topic => topic.key === selectedInsightKey);
            setFilteredRankingTopics(filteredByFeature);
        }
    }, [trackFeaturesRanking, selectedInsights]);

    return (
        <div className="d-flex w-100 justify-content-between flex-wrap">
            <div className="d-flex align-items-center flex-wrap">
                <span className="mr-3">{t("GENERAL.TRACKS")}:</span>
                <CustomDropdown
                    placeholder={t("GENERAL.TRACKS")}
                    variant="light"
                    options={metricsTracks || []}
                    selected={selectedTrackMetrics || null}
                    setSelected={setSelectedTrackMetrics}
                />
            </div>
            <div className="d-flex align-items-center flex-wrap mb-3 mb-md-0">
                <span className="mr-3">{t("GENERAL.INSIGHTS")}:</span>
                <NetgraphNavbarBadges
                    insightsOptions={allAvailableInsights}
                    selectedInsights={selectedInsights}
                    setSelectedInsights={setSelectedInsights}
                />
            </div>
        </div>
    );
};

export default TopDropdowns;
